__turbopack_context__.v({
  "bottomContent": "TestCard-module__slIFSG__bottomContent",
  "ctaContainer": "TestCard-module__slIFSG__ctaContainer",
  "expandableRoot": "TestCard-module__slIFSG__expandableRoot",
  "moreParameter": "TestCard-module__slIFSG__moreParameter",
  "testCardRoot": "TestCard-module__slIFSG__testCardRoot",
  "topContent": "TestCard-module__slIFSG__topContent",
});
